/* 
  For listing redirects. E.g.,
  {
    from: 'market-office-suite--tenderloin--san-francisco--ca',
    to: 'market-office-suite--union-square--san-francisco--ca'
  }
*/
export const slugsToRedirect: { from: string; to: string }[] = [];
